import { Autocomplete, Divider, Stack, TextField, Tooltip, Typography } from '@mui/material'
import { INode, NodeType } from '../../../../definitions/Nodes'
import { IAcceptedData } from '../../../../definitions/NodesDescription'
import { InfoRounded } from '@mui/icons-material'

interface P {
    acceptedData: IAcceptedData<NodeType>
    selectedNode: INode<NodeType>
    setSelected: (node: INode) => void
    disable: boolean
}

const renderTooltip = (title: string, disable: boolean) => (
    <Tooltip arrow title={title} disableHoverListener={disable}>
        <InfoRounded sx={{ cursor: disable ? undefined : 'pointer', color: disable ? 'var(--icon-disabled)' : 'var(--icon-color)' }} />
    </Tooltip>
)

function NodeDataframeFillEditor({ selectedNode: node, acceptedData, setSelected, disable }: P) {
    const myNode = node as INode<'var_dataframe'>
    const fill = myNode.data.fill ?? { from: null, granularity: null, to: null }

    return (
        <Stack spacing={2}>
            <Divider />
            <Stack flexDirection='row' gap={1}>
                {renderTooltip(acceptedData?.tooltipContent, disable)}
                <Typography variant='subtitle2'>Fill from</Typography>
            </Stack>
            <TextField
                disabled={disable}
                value={fill?.from ?? ''}
                fullWidth
                size='small'
                onChange={e => {
                    const newValue = e.target.value
                    const newFill = { ...fill, from: newValue }
                    setSelected({ ...node, data: { ...node.data, fill: newFill } })
                }}
                sx={{ marginTop: 1 }}
            />
            <Stack flexDirection='row' gap={1}>
                {renderTooltip(acceptedData?.tooltipContent, disable)}
                <Typography variant='subtitle2'>Fill To</Typography>
            </Stack>
            <TextField
                disabled={disable}
                value={fill?.to ?? ''}
                fullWidth
                size='small'
                onChange={e => {
                    const newValue = e.target.value
                    const newFill = { ...fill, to: newValue }
                    setSelected({ ...node, data: { ...node.data, fill: newFill } })
                }}
                sx={{ marginTop: 1 }}
            />
            <Stack flexDirection='row' gap={1}>
                {renderTooltip(acceptedData?.tooltipContent, disable)}
                <Typography variant='subtitle2'>Granularity</Typography>
            </Stack>
            <Autocomplete
                disabled={disable}
                size='small'
                options={[
                    { value: 'days', label: 'Days' },
                    { value: 'months', label: 'Months' }
                ]}
                value={acceptedData?.options?.find(x => x?.value === fill.granularity) ?? null}
                getOptionLabel={option => option.label}
                onChange={(e, v) => {
                    e.preventDefault()
                    const newValue = v.value
                    const newFill = { ...fill, granularity: newValue }
                    setSelected({ ...node, data: { ...node.data, fill: newFill } })
                }}
                renderInput={params => {
                    return (
                        <TextField
                            {...params}
                            size='small'
                            fullWidth
                        />
                    )
                }}
                sx={{ marginTop: 1 }}
            />
        </Stack>
    )
}

export default NodeDataframeFillEditor
